import { Box, Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

import { TProjectTheme } from 'src/global/types/theme.type';
import { combineHexAndOpacity } from 'src/utils/helpers';

export function ThemePreviewLayout(props: PropsWithChildren<{ theme: TProjectTheme }>) {
  const { children, theme } = props;
  return (
    <Box
      width={'100%'}
      paddingY={'10px'}
      bgcolor={combineHexAndOpacity(theme.theme.background.color, theme.theme.background.colorOpacity)}>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        padding={'5.3px 10px'}
        sx={{
          borderBottom: `1px solid ${combineHexAndOpacity(theme.theme.container.color, theme.theme.container.colorOpacity)}`,
          borderTop: `1px solid ${combineHexAndOpacity(theme.theme.container.color, theme.theme.container.colorOpacity)}`,
        }}>
        <Box
          bgcolor={theme.theme.container.color}
          width={'32.8px'}
          height={'10.3px'}
          borderRadius={`${theme.components.cornerRadius}px`}
          sx={{
            opacity: theme.theme.container.colorOpacity,
          }}
        />
        <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={'3.54px'}>
          <Box
            bgcolor={theme.theme.container.color}
            width={'47px'}
            height={'10.3px'}
            borderRadius={`${theme.components.cornerRadius}px`}
            sx={{
              opacity: theme.theme.container.colorOpacity,
            }}
          />
          <Box
            bgcolor={theme.theme.bgColorButton.primary}
            width={'47px'}
            height={'10.3px'}
            borderRadius={`${theme.components.cornerRadius}px`}
            sx={{
              opacity: theme.theme.bgColorButton.primaryOpacity,
            }}
          />
        </Stack>
      </Stack>
      <Box width={'100%'}>{children}</Box>
      <Stack
        sx={{
          borderBottom: `1px solid ${combineHexAndOpacity(theme.theme.container.color, theme.theme.container.colorOpacity)}`,
          borderTop: `1px solid ${combineHexAndOpacity(theme.theme.container.color, theme.theme.container.colorOpacity)}`,
        }}
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        padding={'4.9px 10px'}>
        <Stack direction={'row'} justifyContent={'start'} alignItems={'center'} spacing={'6.53px'}>
          <Box
            bgcolor={theme.theme.container.color}
            width={'20.4px'}
            height={'3.67px'}
            borderRadius={`${theme.components.cornerRadius}px`}
            sx={{
              opacity: theme.theme.container.colorOpacity,
            }}
          />
          <Box
            bgcolor={theme.theme.container.color}
            width={'20.4px'}
            height={'3.67px'}
            borderRadius={`${theme.components.cornerRadius}px`}
            sx={{
              opacity: theme.theme.container.colorOpacity,
            }}
          />
          <Box
            bgcolor={theme.theme.container.color}
            width={'20.4px'}
            height={'3.67px'}
            borderRadius={`${theme.components.cornerRadius}px`}
            sx={{
              opacity: theme.theme.container.colorOpacity,
            }}
          />
        </Stack>
        <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={'3.54px'}>
          <Box
            bgcolor={theme.theme.container.color}
            width={'28.5px'}
            height={'6.53px'}
            borderRadius={`${theme.components.cornerRadius}px`}
            sx={{
              opacity: theme.theme.container.colorOpacity,
            }}
          />
          <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={'3.26px'}>
            <Box
              bgcolor={theme.theme.container.color}
              width={'6.53px'}
              height={'6.53px'}
              borderRadius={'100%'}
              sx={{
                opacity: theme.theme.container.colorOpacity,
              }}
            />
            <Box
              bgcolor={theme.theme.container.color}
              width={'6.53px'}
              height={'6.53px'}
              borderRadius={'100%'}
              sx={{
                opacity: theme.theme.container.colorOpacity,
              }}
            />
            <Box
              bgcolor={theme.theme.container.color}
              width={'6.53px'}
              height={'6.53px'}
              borderRadius={'100%'}
              sx={{
                opacity: theme.theme.container.colorOpacity,
              }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
